function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "100%",
  x2: "50%",
  y2: "0%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4755C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CE5178",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M39.293 813H47c4.411 0 8-3.14 8-7 0-3.859-3.589-7-8-7-4.41 0-8 3.141-8 7 0 1.537.568 3 1.642 4.232.335.387.327.963-.02 1.338L39.292 813zM47 815H37a1 1 0 0 1-.733-1.68l2.306-2.484C37.541 809.392 37 807.735 37 806c0-4.963 4.486-9 10-9s10 4.037 10 9-4.486 9-10 9z",
  fill: "url(#a)",
  transform: "translate(-36 -797)",
  fillRule: "evenodd"
});

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Chat.aa750d9e.svg";
export { ForwardRef as ReactComponent };